module.exports = __webpack_public_path__ + "static/media/green_mark_icon.ef0f7904.svg";